/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopcommunication4Inputs */

const de__field_participatedulworkshopcommunication4 = /** @type {(inputs: _Field_Participatedulworkshopcommunication4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Communication`)
};

/**

* @param {_Field_Participatedulworkshopcommunication4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopcommunication4 = /** @type {((inputs?: _Field_Participatedulworkshopcommunication4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopcommunication4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopcommunication4(inputs)
});
export { _field_participatedulworkshopcommunication4 as "_field_participatedULWorkshopCommunication" }